<template>
  <div
      v-if="showInfoBar && deviceType() && deviceType() !== 'desktop'"
      id="infoBar"
      class="sm:hidden flex sticky top-[var(--main-header-height)] z-[80] justify-between gap-2 items-center py-1.5 max-h-[3.75rem] w-full gradient-bg px-3"
  >
    <!-- A link or Text Invitation -->
    <div
        v-if="showLinkButton"
        class="flex items-center sm:hidden justify-center"
    >
      <NuxtLink
          to="/"
          class="bg-white hover:bg-slate-100 text-blue-800 flex items-center gap-1 font-semibold sm:text-xs text-[0.57rem] whitespace-nowrap py-[.50rem] px-4 text-center rounded-md"
          aria-label="Go to homepage"
      >
        {{ buttonLabel }}
      </NuxtLink>
    </div>
    <p v-else class="text-white sm:text-base text-xs">
      {{ $t("general.cezma_is_better_on_app") }}
    </p>
    <!-- Horizontal bar -->
    <div
        v-show="showLinkButton"
        class="w-[0.08rem] h-[1.68rem] bg-gray-400 rounded-sm"
    />
    <!-- Download app button -->
    <div class="flex justify-between sm:gap-6 gap-2.5 items-center w-fit">
      <button
          class="bg-white hover:bg-slate-100 text-blue-800 flex items-center gap-1 font-semibold sm:text-xs text-[0.57rem] whitespace-nowrap py-[.50rem] px-4 text-center rounded-md"
          @click="handleClickBtn"
          aria-label="Download the app"
      >
        {{ $t("general.download_app") }}
        <svg
            class="fill-current w-3 h-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            aria-hidden="true"
        >
          <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
      </button>

      <button
          @click="handleCloseInfoBar"
          class="w-3.5 hover:scale-90 duration-100"
          aria-label="Close the information bar"
      >
        <img
            src="@/assets/images/close.svg"
            alt="Close"
            class=""
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useGlobalStore } from "@/store/Modules/global.js";
export default {
  name: "InfoBar",
  props: {
    infoData: {
      type: Object,
      required: false,
      default: {
        description: "please download app",
      },
    },
  },
  setup() {
    const global = useGlobalStore() || {}; //savedHomepageData:{location,receivedData} ,updateHomepageData
    const route = useRoute();
    return {
      global,
      route,
    };
  },
  data() {
    return {
      showInfoBar: true,
    };
  },
  methods: {
    handleCloseInfoBar() {
      this.showInfoBar = false;
    },
    handleClickBtn() {
      if (!process.client) {
        return;
      }
      this.deviceType() == "android"
        ? window.open(this.layout?.platforms?.android_link, "_blank")
        : window.open(this.layout?.platforms?.ios_link, "_blank");
    },
    deviceType() {
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) {
        if (isAndroid) {
          return "android";
        } else if (isiOS) {
          return "ios";
        } else {
          return false;
        }
      } else {
        return "desktop";
      }
    },
  },
  computed: {
    ...mapState(useGlobalStore, ["layout"]),
    isPlatformsLinksExist() {
      return (
        this.layout?.platforms?.android_link || this.layout?.platforms?.ios_link
      );
    },
    isHomepage() {
      return !this.route.name || this.route.name === "index";
    },
    showLinkButton() {
      return !this.isHomepage;
    },
    buttonLabel() {
      switch (this.route.name) {
        case "products-storeusername-id-productname": //product page
          return this.$t("general.more_products");
        case "store-username": //store page
          return this.$t("general.homepage");
        default:
          return this.$t("general.homepage");
      }
    },
  },
};
</script>

<style scoped>
.gradient-bg {
  background: #020024;
  background: linear-gradient(
    14deg,
    #080451 1%,
    #0d0d83 49%,
    #163761 93%,
    #163761
  );
}
</style>
